// @ts-check

import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";

/**
 * @typedef {{
 * otpRequired: boolean;
 * otpSent: boolean;
 * isSendingOtp: boolean;
 * }} OtpConfig
 */

const PreWithdrawForm = ({ onGenerateOtp, withdrawOtpConfig, onSubmit }) => {
  const [otp, setOtp] = useState("");

  return (
    <>
      <Form className="gatewayForm">
        <p
          style={{
            fontSize: "18px",
            fontWeight: 600,
            textAlign: "center",
          }}
        >
          Complete verification to withdraw
        </p>
        <Form.Group
          className="mb-3 position-relative"
          controlId="formBasicUserName"
        >
          <Form.Control
            type={"text"}
            placeholder={"Enter OTP"}
            name={"otp"}
            onChange={(e) => setOtp(e.target.value)}
          />
          <span className="focus-border">
            <i></i>
          </span>
        </Form.Group>
        <div className="d-flex">
          <Button
            onClick={() => onSubmit(otp)}
            disabled={withdrawOtpConfig?.otpSent == false || !otp || otp === ""}
          >
            {" "}
            Submit
          </Button>

          <Button
            onClick={onGenerateOtp}
            disabled={withdrawOtpConfig?.otpSent}
            className="mx-2"
          >
            {withdrawOtpConfig?.isSendingOtp ? "Requesting..." : "Generate OTP"}
          </Button>
        </div>
      </Form>
    </>
  );
};
export default PreWithdrawForm;
